import {
    getInvoice,
    listInvoices
} from './queries';
import {
    createInvoice,
    deleteInvoice,
    sendInvoice,
    updateInvoice,
    voidInvoice,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateInvoice,
    DeleteInvoice,
    GetInvoice,
    Invoice,
    ListInvoices,
    SendInvoice,
    UpdateInvoice,
    VoidInvoice
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (filter: object, limit?: number, nextToken?: string) => {
    const response = await client.graphql<GraphQLQuery<ListInvoices>>({
                                                                          query: listInvoices,
                                                                          variables: {filter: filter, limit, nextToken},
                                                                      });
    return response.data?.listInvoices;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetInvoice>>({
                                                                        query: getInvoice,
                                                                        variables: {id: id},
                                                                    });
    return response.data?.getInvoice;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateInvoice>>({
                                                                           query: createInvoice,
                                                                           variables: {input: payload},
                                                                       });
    return response.data?.createInvoice;
};

export const update = async (_id: string, record: Invoice) => {
    const payload = {...record} as Record<string, unknown>;
    delete payload.created;
    delete payload.updated;

    const response = await client.graphql<GraphQLQuery<UpdateInvoice>>({
                                                                           query: (updateInvoice),
                                                                           variables: {input: payload},
                                                                       });
    return response.data?.updateInvoice;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteInvoice>>({
                                                                           query: (deleteInvoice),
                                                                           variables: {input: {id: id}},
                                                                       });
    return response.data?.deleteInvoice;
};

export const send = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<SendInvoice>>({
                                                                         query: (sendInvoice),
                                                                         variables: {input: {id: id}},
                                                                     });
    return response.data?.sendInvoice;
};

export const voidRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<VoidInvoice>>({
                                                                         query: (voidInvoice),
                                                                         variables: {input: {id: id}},
                                                                     });
    return response.data?.voidInvoice;
};
